import { SpecificRule } from "../../types/RuleTypes";
import { replaceAll } from "../Utility";

/**
 * Parses a specific rule of type "on_the" and returns a string representation.
 * @param rule the OnThe rule to parse
 * @returns human-readable string representation of the rule
 */
export function parseType_Every(rule: SpecificRule<"every">): string {
  let text = "";

  // if the periodType is set, no specific values are set. so we return the periodType
  if (rule.periodType) return rule.periodType;

  // if the periodType is not set, we need the period and the corrsponding number
  const period = replaceAll(rule.period ?? "", "_", " ");
  text += `${rule.number} ${period}`;

  // if the timeRange is not set, we dont need to add anything else
  if (!rule.timeRange) return text;

  const timerange = replaceAll(rule.timeRange, "_", " ");
  text += ` ${timerange} ${rule.timeRangeNumberStart}`;

  // add the starting on period if the timeRange is set to "starting_on_the"
  if (rule.timeRange === "starting_on_the") text += ` ${period}`;

  // add the end number if the timeRange is set to "ending_on_the"
  if (rule.timeRange === "between_the")
    text += ` and ${rule.timeRangeNumberEnd}`;

  return text.trim();
}
